import React from 'react';
import '../assets/scss/webinar.scss';

function Chats(props) {
  const { id, name, profilePic, question, userId } = props;
  return (
    <div className={`chatBox ${!id || id == userId ? 'chatBoxSent' : 'chatBoxReceived'}`}>
      <img src={profilePic} className={'chatUserPic'} />
      <div className={'chatUserName'}>{name}</div>
      <div className={'chatText'}>{question}</div>
    </div>
  );
}

export default Chats;
